'use client';

import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { ButtonBase } from '../../../../common/components/ButtonBase/ButtonBase';
import { TradeOptionsDrawer } from '../../../../trade/TradeDrawer/TradeDrawerProper/TradeOptionsDrawer';
import { UserAccessWithRoleCheck } from '../../../../common/utils/userAccess/UserAccessWithRoleCheck';
import { useModalDrawerContext } from '../../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { FilledMore } from '../../../../common/svgIcons';

interface AssetDetailsCTAMoreButtonProps {
  isBuyDisabled: boolean;
  isSellDisabled: boolean;
  assetId?: string;
  isOwningAsset?: boolean;
}

const moreButtonStyles = css({
  borderEndEndRadius: 'extra_largeBottomRight !important',
  borderEndStartRadius: 'extra_largeTopRight !important',
  borderStartStartRadius: 'extra_largeTopLeft !important',
  borderStartEndRadius: 'extra_largeBottomLeft !important',
  width: '56px',
  height: '56px',
});

export const AssetDetailsCTAMoreButton: FC<AssetDetailsCTAMoreButtonProps> = ({
  isBuyDisabled,
  isSellDisabled,
  isOwningAsset,
}) => {
  const { openDrawer } = useModalDrawerContext();

  const handleClick = () =>
    openDrawer(TradeOptionsDrawer, {
      position: 'bottom',
      disableCloseButton: true,
      isBuyDisabled,
      isSellDisabled,
      isOwningAsset,
    });

  return (
    <UserAccessWithRoleCheck>
      <ButtonBase
        data-testid="more-trade-options"
        onClick={handleClick}
        visual="tertiary"
        size="large"
        className={moreButtonStyles}
      >
        <FilledMore />
      </ButtonBase>
    </UserAccessWithRoleCheck>
  );
};
